import { createSelector } from 'reselect';
import TableDefinitions from '../../../../../common/TableDefinitions';
import MrdMonitoringReportsColumns from '../../../component/MrdMonitoringReportsColumns';

export const getIsLoading = (state) => state.listing.MRD_MONITORING_REPORT_ALL_MRDS.isLoading;
export const getData = TableDefinitions.MRD_MONITORING_REPORT_ALL_MRDS.getDataFunction();
export const getColumns = createSelector(getData, MrdMonitoringReportsColumns);
